import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../../dialog/dialog-config';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'app-show-pdf',
    templateUrl: './show-pdf.component.html',
    styleUrls: ['./show-pdf.component.scss'],
    standalone: false
})
export class ShowPdfComponent implements OnInit {
  _currentData: any;
  key:any = "";


  constructor(private dialogConfig: DialogConfig, private baseService: BaseService) { }

  ngOnInit() {
    this._currentData = this.dialogConfig.data;

    if(this.dialogConfig.data && this.dialogConfig.data.item != undefined){
      this.key = this.dialogConfig.data.action.key == undefined ? "": this.dialogConfig.data.action.key
      this._currentData = this.dialogConfig.data.item
    }
    if (this._currentData.id) {
      this.baseService.get(this.key==""?this._currentData.id:this._currentData[this.key], "", 'userImage/image-byte-array', 'dms').subscribe(
        (data: any) => {
          if (data.errCode == 0) {
            this._currentData.contentType = data.contentType;
            let contentType = 'data:' + data.contentType + ';base64, ';
            let imagebase64 = contentType + data.imageData;
            if (this._currentData.contentType != 'application/pdf') {
              this._currentData.imageSrc = [];
              this._currentData.fileData = [];
              this._currentData.fileData[0] = { 'name': data.documentName };
              this._currentData.imageSrc[0] = imagebase64;
            }
            else {
              this._currentData.url = imagebase64;
              this._currentData.blob = imagebase64;
            }
            this._currentData.showDoc = true;
          } else {

          }
        }
      );
    }
  }

}
